import { render, staticRenderFns } from "./editBuildingGoogleMap.vue?vue&type=template&id=08663b44&"
import script from "./editBuildingGoogleMap.vue?vue&type=script&lang=js&"
export * from "./editBuildingGoogleMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports